var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-nav'),_c('top-search',{attrs:{"isShowSearch":false}}),_c('div',{staticClass:"main-bg"},[_c('div',{staticClass:"main-wrap"},[_vm._t("crumb"),_vm._t("content")],2)]),_c('Footers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }